<form [formGroup]="form">
  <div mat-dialog-actions>
    <h1 mat-dialog-title *ngIf="data.mode === 'create'">New service cost override</h1>
    <h1 mat-dialog-title *ngIf="data.mode === 'edit'">Edit service cost override</h1>
    <div mat-spacer></div>
    <mat-slide-toggle [formControlName]="'active'" [color]="'accent'" class="mb-3"
      >Active</mat-slide-toggle
    >
  </div>
  <mat-dialog-content flexLayout="row" flexLayoutGap="8px">
    <mat-form-field>
      <mat-label>Fee Based Service</mat-label>
      <mat-select required [formControlName]="'friendlyId'">
        <mat-option
          *ngFor="let service of data.feeBasedServices | async; trackBy: trackByFn"
          [value]="service.friendlyId"
        >
          {{ service.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Fee</mat-label>
      <input title="Fee" matInput required type="number" [formControlName]="'fee'" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions [attr.align]="'end'">
    <button mat-raised-button type="button" [mat-dialog-close]="{ save: false }">Cancel</button>
    <button
      type="button"
      mat-raised-button
      color="primary"
      [mat-dialog-close]="{ save: true }"
      [disabled]="form.invalid"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
